<!--
사용자(회원사) 정책 수정 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-large">

            <div class="uk-modal-header">
                <h4><i class="material-icons">edit</i>회원사 정책 설정</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <table class="info-table small uk-width-1-1">
                    <colgroup>
                        <col style="width: 12rem">
                        <col>
                    </colgroup>
                    <tbody>
                    <tr>
                        <th class="uk-text-right">
                            회원사
                        </th>
                        <td class="uk-text-left">
                            {{ user.nick }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right">
                            사서함
                        </th>
                        <td class="uk-text-left">
                            {{ user.mailbox }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right" @click="$refs.allowed_register_deposit.inputFocus()">
                            배송등록 허용
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                ref="allowed_register_deposit"
                                v-model="inputs.allowed_register_deposit"
                                placeholder="미설정시, 시스템 기본값(0원) 적용"
                            ></app-input-text>
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right" @click="$refs.allowed_shipout_deposit.inputFocus()">
                            출고제한 허용
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                ref="allowed_shipout_deposit"
                                v-model="inputs.allowed_shipout_deposit"
                                placeholder="미설정시, 시스템 기본값(20,000원) 적용"
                            ></app-input-text>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="uk-text-right text-red">
                    * 예치금잔액이 [배송등록 허용] 금액 미만인 경우 배송등록이 제한됩니다.
                </div>
                <div class="uk-text-right text-gray" style="margin-top: 0.25rem">
                    * 주결제수단이 카드인 경우 배송등록제한이 적용되지 않습니다.
                </div>
                <div class="uk-text-right text-red" style="margin-top: 0.5rem">
                    * 예치금 주결제수단 업체: (예치금잔액 - 미결제총합)이 [출고제한 허용] 금액 미만이면 출고가 제한됩니다.
                </div>
                <div class="uk-text-right text-gray" style="margin-top: 0.25rem">
                    * 출고제한 허용에 음수 설정 시 해당 금액만큼 미결제를 허용합니다. (예: -50,000 → 미결제 50,000원까지 허용)
                </div>
                <div class="uk-text-right text-gray" style="margin-top: 0.25rem">
                    * 카드 주결제수단 업체: 미결제(FAILED) 과금 건수 기반으로 자동 적용됩니다. (출고제한 허용 설정 무관)
                </div>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {
                /**
                 * (object) user
                 */
                user: {},

                /**
                 * (object) 입력값
                 */
                inputs: {
                    allowed_register_deposit: null,
                    allowed_shipout_deposit: null,
                },


            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param user_id
             */
            form(user_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/company-users/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.user = response.user;

                    // 입력값 초기화
                    this.inputs.allowed_register_deposit = this.user.company.allowed_register_deposit;
                    this.inputs.allowed_shipout_deposit = this.user.company.allowed_shipout_deposit;

                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/users/' + this.user.id + '/user-policy',
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>
